var map = {
	"./gallery1.jpg": 7994,
	"./gallery10.jpg": 664,
	"./gallery12.JPG": 7605,
	"./gallery13.JPG": 920,
	"./gallery14.png": 1192,
	"./gallery15.png": 9585,
	"./gallery16.jpeg": 1083,
	"./gallery17.jpg": 5547,
	"./gallery18.jpg": 240,
	"./gallery19.jpg": 1981,
	"./gallery2.jpg": 8485,
	"./gallery20.JPG": 9426,
	"./gallery21.JPG": 6079,
	"./gallery22.jpeg": 5860,
	"./gallery23.jpeg": 1067,
	"./gallery24.jpeg": 1882,
	"./gallery25.jpeg": 3505,
	"./gallery26.jpeg": 4736,
	"./gallery27.jpeg": 2439,
	"./gallery28.jpeg": 5190,
	"./gallery29.jpeg": 2061,
	"./gallery3.jpg": 7304,
	"./gallery30.jpeg": 7679,
	"./gallery31.jpeg": 6136,
	"./gallery32.jpeg": 3529,
	"./gallery33.jpeg": 2898,
	"./gallery34.jpeg": 8979,
	"./gallery35.jpeg": 2300,
	"./gallery36.jpeg": 5181,
	"./gallery37.jpeg": 3846,
	"./gallery38.jpeg": 6487,
	"./gallery39.jpg": 1591,
	"./gallery4.jpg": 907,
	"./gallery5.jpg": 5070,
	"./gallery6.jpg": 3737,
	"./gallery7.jpg": 5740,
	"./gallery8.jpg": 3487,
	"./gallery9.jpg": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7561;